import { store as createStore } from '@risingstack/react-easy-state'
import { InquiryTypes } from '../constants/InquiryTypes'
import { InquiryFrequencies } from '../constants/InquiryFrequencies'
import { sortByDate } from '../utilities/dates'
import { debug } from '../utilities/logger'
import api from '../api'
import { InquiryStatus } from '../constants/InquiryStatus'
import { ProposalStatus } from '../constants/ProposalStatus'

/**
 * [Store]
 */
const store = createStore({
  loading: false,
  list: null,
  inquiry: null,
  selected: null,
  payment: {
    loading: false
  },
  getList,
  get,
  cancel,
  select,
  accept,
  close
})

/**
 * [Cache management]
 */

/**
 * [Functions]
 */
async function getList () {
  store.loading = true
  const result = await Promise.all([
    api.inquiries.list({ frequency: InquiryFrequencies.PONCTUAL, type: InquiryTypes.VISIT }),
    api.inquiries.list({ frequency: InquiryFrequencies.PONCTUAL, type: InquiryTypes.REALISATION }),
    api.inquiries.list({ frequency: InquiryFrequencies.MAINTENANCE, type: InquiryTypes.REALISATION })
  ])
  store.list = result
    .reduce((p, current) => { return [ ...p, ...current.content ] }, [])
    .sort(sortByDate('timestamp'))
  store.loading = false
}

async function setInquiry (inquiry) {
  store.inquiry = inquiry
  if (store.inquiry && store.inquiry.status === InquiryStatus.ACCEPTED && !store.inquiry.isMaintenance) {
    const proposal = store.inquiry.proposals.find((p) => p.status === ProposalStatus.ACCEPTED)
    if (proposal) {
      await select({ proposal: proposal.id })
    }
  }
  if (store.inquiry && store.inquiry.status === InquiryStatus.CANCELLED) {
    store.inquiry.searcheable = false
  }
}

async function get ({ id, frequency, type }) {
  store.loading = true
  // Cleaning
  store.selected = null
  store.payment = { loading: false }

  // Retrieving inquiry
  if (frequency === InquiryFrequencies.MAINTENANCE) {
    await setInquiry(await api.inquiries.maintenance.get({ id, type }))
  } else if (frequency === InquiryFrequencies.PONCTUAL) {
    await setInquiry(await api.inquiries.ponctual.get({ id, type }))
  } else { debug(`[store][inquiry.submit] Unable to find a strategy to get inquiry ${frequency} ${type}`) }

  store.loading = false
}

async function cancel ({ proposal, reason }) {
  if (!store.inquiry || store.inquiry.isMaintenance) { return }
  await api.inquiries.ponctual.cancel({
    id: store.inquiry.id,
    type: store.inquiry.type,
    proposal,
    reason
  })
}

async function select ({ proposal }) {
  store.selected = proposal
  store.payment.loading = true
  store.payment = {
    ...(await api.inquiries.ponctual.getPayment({ id: store.inquiry.id, proposal })),
    loading: false
  }
}

async function accept ({ mean, asAdmin, paymentType } = {}) {
  const { isMaintenance, id, type } = store.inquiry
  const proposal = store.selected

  if (isMaintenance) {
    try {
      await api.inquiries.maintenance.accept({ id, proposal, asAdmin, paymentType })
    } catch (e) {
      window.alert(`Une erreur est survenue lors de la validation du devis, veuillez contacter le support.`)
      throw e
    }
    await store.get({ id, type: InquiryTypes.REALISATION, frequency: InquiryFrequencies.MAINTENANCE })
  } else if (mean) {
    try {
      await api.inquiries.ponctual.pay({ id, type, proposal, mean, paymentType })
    } catch (e) {
      window.alert(`Une erreur est survenue lors de la validation du devis, veuillez contacter le support.`)
      throw e
    }
    await store.get({ id, type: InquiryTypes.REALISATION, frequency: InquiryFrequencies.PONCTUAL })
  }
}

async function close () {
  const isMaintenance = store.inquiry.isMaintenance
  const type = isMaintenance ? InquiryFrequencies.MAINTENANCE : store.inquiry.type
  const id = store.inquiry.id
  const inquiry = isMaintenance
    ? await api.inquiries.maintenance.close({ id })
    : await api.inquiries.ponctual.close({ type, id })
  await setInquiry(inquiry)
}

export default store



// WEBPACK FOOTER //
// ./src/stores/inquiries.js